import { render, staticRenderFns } from "./addnameAuthenticationbind.vue?vue&type=template&id=d6111756&"
import script from "./addnameAuthenticationbind.vue?vue&type=script&lang=js&"
export * from "./addnameAuthenticationbind.vue?vue&type=script&lang=js&"
import style0 from "./addnameAuthenticationbind.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\atmolab_server_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6111756')) {
      api.createRecord('d6111756', component.options)
    } else {
      api.reload('d6111756', component.options)
    }
    module.hot.accept("./addnameAuthenticationbind.vue?vue&type=template&id=d6111756&", function () {
      api.rerender('d6111756', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authentication/components/addnameAuthenticationbind.vue"
export default component.exports